import React from 'react';

const SpreadsheetContext = React.createContext({
  parsedColumns: null
});

export default SpreadsheetContext;
